import isNil from 'lodash/isNil';

import { handleRepeatEvent } from 'components/practice/appointment/EventForm/lib';

const onHandleRepeatAppointment = (val, values, setFieldValue, startDate) => {
  handleRepeatEvent(setFieldValue, val, startDate);
  if (isNil(values.repeat_every)) {
    setFieldValue('repeat_every', 1);
  }
};
export default onHandleRepeatAppointment;
